import { render, staticRenderFns } from "./conferencePolicyTab.vue?vue&type=template&id=9f81e2a4&"
import script from "./conferencePolicyTab.vue?vue&type=script&lang=js&"
export * from "./conferencePolicyTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports